import { useWeb3Modal } from '@web3modal/wagmi/react'
import { useAccount } from 'wagmi';


export const Connect = () => {
    const { open } = useWeb3Modal();
    const { address, isConnected } = useAccount();


    return (
        address && isConnected ? (

            <button onClick={() => open()} type='button' className="button">
                <i className="icon-wallet mr-md-2" /> <span>{`${address.substring(0, 6)}...${address.substring(address.length - 4)}`}</span>
            </button>

        ) : (
            <button onClick={() => open()} type='button' className="button">
                <i className="icon-wallet mr-md-2" />Connect Wallet
            </button>
        )
    )
};